import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Card, Typography, List, ListItem } from '@mui/joy';
import { ArrowLeft as ArrowBack } from '@phosphor-icons/react';
import type { LegalDocument } from './legalContent';

interface Props {
  document: LegalDocument;
}

export const LegalDocumentPage: React.FC<Props> = ({ document }) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        py: { xs: 2, md: 5 },
        px: { xs: 1.5, md: 2 },
      }}
    >
      <Card
        sx={{
          maxWidth: 820,
          mx: 'auto',
          boxShadow: 'lg',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            background: 'linear-gradient(135deg, #7013f5 0%, #5a0fc8 100%)',
            color: 'white',
            p: { xs: 2.5, md: 3 },
          }}
        >
          <Link
            to="/login"
            style={{
              color: 'rgba(255,255,255,0.85)',
              textDecoration: 'none',
              fontSize: '0.875rem',
              display: 'inline-flex',
              alignItems: 'center',
              gap: 4,
              marginBottom: 12,
            }}
          >
            <ArrowBack size={16} />
            Back to Login
          </Link>
          <Typography level="h2" sx={{ color: 'white', fontWeight: 400, fontSize: { xs: '1.4rem', md: '1.75rem' } }}>
            {document.title}
          </Typography>
          <Typography level="body-sm" sx={{ color: 'rgba(255,255,255,0.8)', mt: 0.5 }}>
            Effective Date: {document.effectiveDate}
          </Typography>
        </Box>

        <Box sx={{ p: { xs: 2.5, md: 4 } }}>
          {document.intro && (
            <Typography level="body-md" sx={{ mb: 3 }}>
              {document.intro}
            </Typography>
          )}

          {document.sections.map((section) => (
            <Box key={section.heading} sx={{ mb: 3 }}>
              <Typography level="title-lg" sx={{ mb: 1 }}>
                {section.heading}
              </Typography>
              {section.paragraphs.map((p, idx) => (
                <Typography key={idx} level="body-md" sx={{ mb: 1 }}>
                  {p}
                </Typography>
              ))}
              {section.bullets && (
                <List marker="disc" sx={{ pl: 2 }}>
                  {section.bullets.map((b, idx) => (
                    <ListItem key={idx}>
                      <Typography level="body-md">{b}</Typography>
                    </ListItem>
                  ))}
                </List>
              )}
            </Box>
          ))}
        </Box>
      </Card>
    </Box>
  );
};
